import React from 'react';
import styles from './CustomSelectInput.module.css';
import {ReactComponent as ChevronIcon} from '../../assets/icons/icon_chevron_down.svg';

interface CustomSelectInputProps {
    id: string;
    label?: string;
    list: ListElementType[]
    value: string;
    allowEmpty?: boolean;
    emptyLabel?: string;
    onChange: (event: string) => void;
    disabled?: boolean;
    className?: any;
}

const CustomSelectInput = (props: CustomSelectInputProps) => {
    
    return (
        <div className={styles.select_container}>
            {props.label && <label>{props.label}</label>}
            <span className={styles.select_span}>
                <select
                    value={props.value}
                    onChange={e => props.onChange(e.target.value)}
                    name={props.id}
                    id={props.id}
                    disabled={props.disabled}
                    className={`${props.className} ${styles.select}`}
                >
                    {props.emptyLabel && <option value=''>{props.emptyLabel}</option>}
                    { props.list.map((item, index) => (
                        <option className={styles.option} key={index} value={item.title}>{item.description}</option>
                    ))}
                </select>
                <span className={styles.icon_select}>
                    <ChevronIcon />
                </span>
            </span>
        </div>
    );
}

export default CustomSelectInput;